var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiUserFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 63,
    viewBox: "0 0 69 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3362_5403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4717 63.0661C11.4717 56.9839 13.8878 51.1509 18.1886 46.8501C22.4893 42.5493 28.3224 40.1332 34.4046 40.1332C40.4868 40.1332 46.3199 42.5493 50.6206 46.8501C54.9214 51.1509 57.3375 56.9839 57.3375 63.0661H11.4717ZM34.4046 37.2666C24.9018 37.2666 17.2049 29.5697 17.2049 20.0669C17.2049 10.5641 24.9018 2.86719 34.4046 2.86719C43.9074 2.86719 51.6043 10.5641 51.6043 20.0669C51.6043 29.5697 43.9074 37.2666 34.4046 37.2666Z",
    fill: "#321E5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3362_5403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.9819,
    height: 62.7812,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiUserFill);
export default __webpack_public_path__ + "static/media/ri_user-fill.644bf416d40ad4baff091b6c63ed7f56.svg";
export { ForwardRef as ReactComponent };